import React, { useEffect } from "react";
import "./Privacy_Policy.css";
import Common_Banner from "../common/common-banner/Common_Banner";
import { AllPrivacyPolicy } from "../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";

const Privacy_Policy = () => {
  const dispatch = useDispatch();

  const all_privacy_policy = useSelector(
    (state) => state?.common?.all_privacy_policy,
  );

  useEffect(() => {
    dispatch(AllPrivacyPolicy());
  }, [dispatch]);

  return (
    <section className="Privacy_Policy Terms_Conditions">
      {/* <div className="terms_banner_div">
        <div className="container">
          <h5>Privacy Policy</h5>
        </div>
      </div> */}
      <Common_Banner title="Privacy Policy" />

      <div className="container">
        <div className="terms_content_section">
          {/* <div className="content_holder">
            <h5 className="content_title">GDPR & PRIVACY POLICY</h5>
            <p className="terms_text">
              lipsum.com is committed to protecting your privacy online. This
              Privacy Policy endeavours to describe to you our practices
              regarding the personal information we collect from users on our
              website, located at lipsum.com (the “Site”), and the services
              offered through the Site. If you have any questions about our
              Privacy Policy, our collection practices, the processing of user
              information, or if you would like to report a security violation
              to us directly, please contact us at help@lipsum.com
            </p>
          </div>

          <div className="content_holder">
            <h5 className="content_title">WHAT DATA WE COLLECT</h5>

            <p className="terms_text">
              <span className="dark_text"> General Data: </span>
              The use of our services will automatically create information that
              will be collected. For example, when you use our Services, your
              geographic location, how you use the Services, information about
              the type of device you use, your Open Device Identification
              Number, date/time stamps for your visit, your unique device
              identifier, your browser type, operating system, Internet Protocol
              (IP) address, and domain name are all collected. This information
              is generally used to help us deliver the most relevant information
              to you and administer and improve the Site.
            </p>

            <p className="terms_text">
              <span className="dark_text">Log Files:</span>
              As is true of most websites, we gather certain information
              automatically and store it in log files. This information includes
              IP addresses, browser type, Internet service provider (ISP),
              referring/exit pages, operating system, date/time stamp, and
              clickstream data. We use this information to maintain and improve
              the performance of the Services.
            </p>

            <p className="terms_text">
              <span className="dark_text">Analytics:</span>
              We use analytics services (including, but not limited to, Google
              Analytics) to help analyze how users use the Site. Analytics
              services use Cookies to collect information such as how often
              users visit the Site and we use the information to improve our
              Site and Services. The analytics services' ability to use and
              share information collected by them is restricted by their terms
              of use and privacy policy, which you should refer to for more
              information about how these entities use this information.
            </p>

            <p className="terms_text">
              <span className="dark_text">Location Information:</span>
              If you have enabled location services on your mobile device, we
              may collect your location information to improve the Services we
              offer. If you do not want this information collected, you can
              disable location services on your device.
            </p>

            <p className="terms_text">
              <span className="dark_text"> Cookies:</span>
              “Cookies” are small pieces of information (text files) that a
              website sends to your computer’s hard drive while you are viewing
              the website. These text files can be used by websites to make the
              users experience more efficient. The law states that we can store
              these cookies on your device if they are strictly necessary for
              the operation of this site. For all other types of cookies we need
              your permission. To that end, this site uses different types of
              cookies. Some cookies are placed by third party services that
              appear on our pages. We and some third parties may use both
              session Cookies (which expire once you close your web browser) and
              persistent Cookies (which stay on your computer until you delete
              them) to provide you with a more personal and interactive
              experience on our Services and to market the Services or other
              products. Marketing cookies are used to track visitors across
              websites. The intention is to display ads that are relevant and
              engaging for the individual user and thereby more valuable for
              publishers and third party advertisers. This tracking is done on
              an anonymous basis and, while not an exhaustive list, some of the
              companies we work with are Google, AppNexus, Criteo, Rubicon,
              Pubmatic and DistrictM. To learn more about this practice,
              including the Self Regulatory Principles for Online Advertising,
              to which we adhere, you can visit www.aboutads.info/choices,
              optout.networkadvertising.org and www.youronlinechoices.com
            </p>
          </div>

          <div className="content_holder">
            <h5 className="content_title">USE OF YOUR PERSONAL INFORMATION</h5>
            <p className="terms_text">
              In general, personal information you submit to us is used either
              to respond to requests that you make, aid us in serving you
              better, or market our Services. We use your personal information
              in the following ways:
            </p>

            <p className="terms_text">
              We may store and process your personal information on servers
              located in both the United States and Europe. We may also create
              anonymous data records from your personal information by
              completely excluding information (such as your name) that makes
              the data personally identifiable to you. We use this anonymous
              data to analyze request and usage patterns so that we may enhance
              the content of our Services and improve Site functionality. We
              reserve the right to use anonymous data for any purpose and
              disclose anonymous data to third parties at our sole discretion.
            </p>
          </div>

          <div className="content_holder">
            <h5 className="content_title">
              DISCLOSURE OF YOUR PERSONAL INFORMATION
            </h5>
            <p className="terms_text">
              We disclose your personal information as described below and as
              described elsewhere in this Privacy Policy.
            </p>

            <p className="terms_text">
              <span className="dark_text">
                Third Parties Designated by You:
              </span>
              When you use the Services, the personal information you provide
              will be shared with the third parties that you authorize to
              receive such information.
            </p>

            <p className="terms_text">
              <span className="dark_text">Third Party Service Providers:</span>
              We may share your personal information with third party service
              providers to: provide you with the Services that we offer you
              through our Services; conduct quality assurance testing; to
              provide technical support; market the Services; and/or to provide
              other services to us.
            </p>

            <p className="terms_text">
              <span className="dark_text">Other Disclosures: </span>
              Regardless of any choices you make regarding your Personal
              information (as described below), lipsum.com may disclose Personal
              information if it believes in good faith that such disclosure is
              necessary: (i) in connection with any legal investigation; (ii) to
              comply with relevant laws or to respond to subpoenas or warrants
              served on our company; (iii) to protect or defend the rights or
              property of lipsum.com or users of the Services; and/or (iv) to
              investigate or assist in preventing any violation or potential
              violation of the law, this Privacy Policy, or our Terms of Use.
            </p>
          </div> */}

            {all_privacy_policy?.description && (
            <div
              className="terms_text"
              dangerouslySetInnerHTML={{
                __html: all_privacy_policy.description,
              }}
            />
          )}

        </div>
      </div>
    </section>
  );
};

export default Privacy_Policy;
